export const SPLIT = 'split';
export const UNIFIED = 'unified';
